/* eslint-disable global-require */
import {
  VBTooltip,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { mapActions } from 'vuex'
import FlipCountdown from 'vue2-flip-countdown'
import store from '@/store'
import AuthApis from '@/services/apis/auth'

const auth = new AuthApis()
export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    FlipCountdown,
  },
  data() {
    return {
      status: '',
      code: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      required,
      email,
      pending: false,
      pendingResend: false,
      disable: true,
      deadline: this.getExpireTime(),
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  created() {
    if (!localStorage.getItem('email')) {
      this.$router.push(`/${this.$i18n.locale}/login`)
    }
  },
  methods: {
    ...mapActions(['loginSection2']),
    async submit() {
      const success = await this.$refs.loginForm.validate()
      if (success) {
        this.pending = true
        const data = { code: this.code, email: localStorage.getItem('email') }
        this.loginSection2(data).then(res => {
          window.dataLayer.push({
            event: 'login',
          })
          this.$swal({
            title: `${this.$t('login_message')}`,
            icon: 'success',
            timer: 2500,
            showConfirmButton: false,
          })
          this.$router.push(`${this.$route.query.redirect ? `${this.$route.query.redirect}` : `/${res.data.results.user.language}/profile`}`)
        }).finally(() => {
          this.pending = false
        })
      }
    },

    timeElapsedHandler() {
      this.disable = false
    },

    async resend() {
      this.pendingResend = true
      const data = { email: localStorage.getItem('email') }
      const response = await auth.resendCode(data).finally(() => {
        this.pendingResend = false
      })
      this.$swal({
        title: response?.data?.message,
        icon: 'success',
        timer: 2500,
        showConfirmButton: false,
      })
      if (response.status === 200) {
        this.disable = true
        this.deadline = this.getExpireTime()
      }
    },

    onVerify(response) {
      this.form.recaptcha = response
    },

    async onCaptchaExpired() {
      this.$refs.recaptcha.reset()
    },

    getExpireTime() {
      const expireTime = localStorage.getItem('expireTime')
      const currentDate = new Date()
      const msSinceEpoch = currentDate.getTime()
      const seventeenHoursLater = new Date(msSinceEpoch + expireTime * 60 * 1000)
      const currentDayOfMonth = seventeenHoursLater.getDate()
      const currentMonth = seventeenHoursLater.getMonth()
      const currentYear = seventeenHoursLater.getFullYear()
      const hours = seventeenHoursLater.getHours()
      const minutes = seventeenHoursLater.getMinutes()
      const seconds = seventeenHoursLater.getSeconds()
      const dateString = `${currentYear}-${currentMonth + 1}-${currentDayOfMonth} ${hours}:${minutes}:${seconds}`
      return dateString
    },
  },
}
